import styled from "styled-components";
import { CSSVars } from "../../styles/styles.config";

export const StyledPricingSummary = styled.section`
	background: ${CSSVars.gray50};
	color: ${CSSVars.black};
	padding: 50px 20px;

	@media screen and (min-width: ${CSSVars.breakpointMD}) {
		padding: 75px 30px;
	}

	@media screen and (min-width: ${CSSVars.breakpointLG}) {
		padding: 100px 40px;
	}
`;

export const StyledInner = styled.div`
	max-width: 1100px;
	margin: 0 auto;
	text-align: center;
`;

export const StyledTitle = styled.h2`
	font-family: ${CSSVars.primaryFont};
	font-weight: 600;
	font-size: ${CSSVars.fontSize2XL};
	margin-bottom: 10px;

	@media screen and (min-width: ${CSSVars.breakpointMD}) {
		font-size: ${CSSVars.fontSize3XL};
	}
`;

export const StyledSubtitle = styled.p`
	font-family: ${CSSVars.secondaryFont};
	font-weight: 300;
	font-size: ${CSSVars.fontSizeMD};
	color: ${CSSVars.gray700};
	margin-bottom: 40px;
`;

export const StyledPlanList = styled.ul`
	list-style: none;
	display: grid;
	grid-template-columns: 1fr;
	gap: 16px;

	@media screen and (min-width: ${CSSVars.breakpointMD}) {
		grid-template-columns: repeat(2, 1fr);
	}

	@media screen and (min-width: ${CSSVars.breakpointLG}) {
		grid-template-columns: repeat(4, 1fr);
	}
`;

export const StyledPlan = styled.li`
	background: ${CSSVars.white};
	border: 1px solid ${CSSVars.gray200};
	border-radius: 8px;
	padding: 24px 20px;
	text-align: left;
`;

export const StyledPlanName = styled.h3`
	font-family: ${CSSVars.primaryFont};
	font-weight: 600;
	font-size: ${CSSVars.fontSizeLG};
	margin-bottom: 8px;
`;

export const StyledPlanPrice = styled.p`
	font-family: ${CSSVars.primaryFont};
	font-weight: 700;
	font-size: ${CSSVars.fontSize2XL};
	color: ${CSSVars.blue500};
	margin-bottom: 4px;

	span {
		font-family: ${CSSVars.secondaryFont};
		font-weight: 300;
		font-size: ${CSSVars.fontSizeSM};
		color: ${CSSVars.gray700};
	}
`;

export const StyledPlanNote = styled.p`
	font-family: ${CSSVars.secondaryFont};
	font-weight: 300;
	font-size: ${CSSVars.fontSizeSM};
	color: ${CSSVars.gray600};
`;

export const StyledFootnote = styled.p`
	font-family: ${CSSVars.secondaryFont};
	font-weight: 300;
	font-size: ${CSSVars.fontSizeSM};
	color: ${CSSVars.gray600};
	margin-top: 30px;
`;
